import { render } from "./NovncConsoleWrapper.vue?vue&type=template&id=15f177c8&scoped=true"
import script from "./NovncConsoleWrapper.vue?vue&type=script&lang=js"
export * from "./NovncConsoleWrapper.vue?vue&type=script&lang=js"

import "./NovncConsoleWrapper.vue?vue&type=style&index=0&id=15f177c8&lang=scss&scoped=true"
import "./NovncConsoleWrapper.vue?vue&type=style&index=1&id=15f177c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f177c8"]])

export default __exports__